/**
 * @file 主账号信息页面
 */
<template>
  <div class="p-account-detail">
    <div v-if="overViewInfo" class="p-account-detail-form">
      <plv-form
        ref="form"
        form-width="600px"
        label-width="110px"
        :model="form"
        :rules="rules"
      >
        <plv-form-item
          label="集团账号邮箱"
          label-height="16px"
        >
          <div class="p-account-detail-item">{{ overViewInfo.email }}</div>
        </plv-form-item>
        <plv-form-item
          label="账号密码"
          label-height="16px"
        >
          <div class="p-account-detail-item">
            <span>******</span>
            <span class="p-link-btn" @click="handleResetModal">重置密码</span>
          </div>
        </plv-form-item>
        <plv-form-item
          label="联系人"
        >
          <plv-input
            v-model="form.contact"
            size="medium"
            placeholder="请输入联系人姓名"
            :maxlength="50"
            :en-length="1"
          />
        </plv-form-item>
        <plv-form-item
          prop="phone"
          label="手机号码"
        >
          <plv-input
            v-model="form.phone"
            size="medium"
            placeholder="请输入联系人手机号码"
          />
        </plv-form-item>
        <plv-form-item
          prop="website"
          label="机构网址"
        >
          <plv-input
            v-model="form.website"
            size="medium"
            placeholder="请输入机构网址"
            :maxlength="50"
            :en-length="1"
          />
        </plv-form-item>
        <plv-form-item
          label-height="16px"
          label="groupId"
        >
          {{ overViewInfo.groupId }}
        </plv-form-item>
        <plv-form-item
          label-height="16px"
          label="AppID"
        >
          {{ overViewInfo.appId }}
        </plv-form-item>
        <plv-form-item
          label-height="16px"
          label="AppSecret"
        >
          {{ overViewInfo.appSecret }}
        </plv-form-item>
        <plv-form-item>
          <plv-button @click="handleSubmit">保存</plv-button>
        </plv-form-item>
      </plv-form>
    </div>
    <reset-psw-modal :visible.sync="resetPswVisible" @resetPassword="handleResetPassword" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { defaultFormRules } from '@/utils/type';
import ResetPswModal from '@component/resetPswModal/resetPswModal';
export default {
  components: {
    ResetPswModal
  },
  data() {
    return {
      resetPswVisible: false, // 重置密码弹窗
      form: {
        contact: '',
        phone: '',
        website: ''
      },
      rules: Object.assign({}, defaultFormRules)
    };
  },
  computed: {
    ...mapGetters({
      overViewInfo: 'account/overViewInfo'
    }),
    currentId() {
      return this.$route.params.id;
    }
  },
  watch: {
    overViewInfo: {
      handler(value) {
        this.form.phone = value.phone ?? '';
        this.form.website = value.website ?? '';
        this.form.contact = value.contact ?? '';
      },
      immediate: true
    }
  },
  methods: {
    handleResetModal() {
      this.resetPswVisible = true;
    },
    async handleSubmit() {
      this.$refs.form.validate();
      try {
        this.$emit('loading');
        await this.$store.dispatch('account/updateAccountInfo', this.form);
        this.$toast.success('保存成功');
      } finally {
        this.$emit('cancelLoading');
      }
    },
    async handleResetPassword(form) {
      const params = {
        password: form.password
      };
      try {
        this.$emit('loading');
        await this.$store.dispatch('account/updateAccountInfo', params);
        this.$toast.success('修改密码成功');
        this.resetPswVisible = false;
      } catch (e) {
        this.$toast.error(e);
      } finally {
        this.$emit('cancelLoading');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.p-account-detail {
  .p-link-btn {
    margin-left: 5px;
    color: #2196f3;
    cursor: pointer;
    font-size: 14px;
    &:active {
      opacity: .7;
    }
  }
  .plv-date-picker {
    margin-left: 10px !important;
  }
  .plv-radio-group {
    align-items: center;
  }
}
</style>
